module.exports = __webpack_public_path__ + "img/it-2.32b5c888.png";